const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5,
    position: 'relative',
    minHeight: 48
  },
  title: {
    marginRight: [theme.spacing.unit * 5]
  },
  infoItemTitle: {
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  },
  gridItem: {
    padding: [theme.spacing.unit, '!important']
  },
  infoTitle: {
    marginBottom: theme.spacing.unit
  },
  detailsSection: {
    '&:last-child': {
      marginTop: [theme.spacing.unit * 3]
    }
  },
  url: {
    color: theme.palette.primary.main,
    textDecoration: 'none'
  }
});

export default styles;
